import { render } from "./widget-download.vue?vue&type=template&id=4c3cd86f&scoped=true&ts=true"
import script from "./widget-download.vue?vue&type=script&lang=ts"
export * from "./widget-download.vue?vue&type=script&lang=ts"

import "./widget-download.vue?vue&type=style&index=0&id=4c3cd86f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3cd86f"]])

export default __exports__